import { sendMessage } from "actions";
import { DriverSession } from "lib/deviceDrivers/sessionFramework/runtime/DriverSession";
import { toastNotifier } from "lib/deviceDrivers/sessionFramework/adapter/toastNotifier";
import { createXrp2iDevice } from "lib/deviceDrivers/truTest/xrp2i/device/createProtocol";
import {
  mapDeviceEventToDriverEffects,
  type DriverAction,
  type DriverActionResult,
  type DriverNotifier,
} from "lib/deviceDrivers/truTest/xrp2i/adapters/driverEffects";
import type {
  Xrp2iDeviceHandle,
  Xrp2iEvent,
} from "lib/deviceDrivers/truTest/xrp2i/device/types";

export class Xrp2iDriverSession extends DriverSession<
  Xrp2iDeviceHandle,
  DriverAction,
  Xrp2iEvent
> {
  constructor(deviceId: string, notifier: DriverNotifier = toastNotifier) {
    super(
      deviceId,
      createXrp2iDevice,
      (id, payload) => sendMessage(id, payload),
      mapDeviceEventToDriverEffects,
      notifier,
    );
  }

  /**
   * Triggers a hardware configuration reset and returns any Redux actions queued during that reset. The sync step runs on connection so the driver learns the scanner's line-ending and EID output-format state before live frames arrive.
   */
  syncState(): DriverActionResult {
    void this.device.resetHardwareConfig();
    return this.drainEffects();
  }

  /**
   * Queries the device date and time, computes drift against the system clock, then writes the corrected time. A warning is emitted if the drift exceeds the significant threshold.
   */
  setDeviceTime(): DriverActionResult {
    this.device.setDeviceTime();
    return this.drainEffects();
  }
}
